export default "__VITE_ASSET__BQkUjV5u__"